
const currencyTimer = {
    resetTime: 'RESET_TIME',
    updateTime: 'UPDATE_TIME',
};

export default currencyTimer;